/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {
    "use strict";

    export class DashboardController {
        public static $inject : string[] = [];

        constructor() {}
    }

    getDealerwareWebContentModule().controller('DashboardController', DashboardController);
}
